import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { GreyOutlinedButton } from "../Button/CustomButton";
import Autocomplete from "@mui/material/Autocomplete";
import { colors } from "../../Styles/GlobalStyles/Variables";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import generalFunc from "../../Utils/generalFunc";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import NotFoundImage from "../../Assets/NotFound/search-not-found.gif";
import Iconify from "../Dashboard/Iconify";
import { StyledDivider } from "../Divider/StyledDivider";
import { LighterGreenButton } from "../Button/CustomButton";
import Typography from "@mui/material/Typography";
import validators from "../../Utils/Validators";


import {
  Grid,
  Button,
  Box,
  Skeleton,
  FormControl,
  IconButton,
  TextField,
} from "@mui/material";
import {
  addCMToLoan,
  emptyCorpsMember,
  fetchCorpsMember,
  fetchLBToLoan,
  fetchLoans,
  restoreLBToLoanInitial,
} from "../../Actions";
import { isSignedIn } from "../../Hooks/auth";

const getLoanState = (state) => state.loansReducer;
const getCMState = (state) => state.usersReducer;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddCMToLoanDialog(props) {
  const {
    addCMToLoanDialogIsOpen,
    handleCloseAddCMToLoanDialog,
    updateLoadingState,
    loanData,
  } = props;

  const ToastStyle = {
    backgroundColor: "#d56b66",
    color: colors.white,
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const user = JSON.parse(isSignedIn);
  const initialFormValues = {
    stateCode: "",
    stateId: user?.stateID,
    userId: user?.id,
    hash: "",
    addCMtoLoanFormValues: {
      cmName: "",
      cmStateCode: "",
      loanId: loanData?.id,
    },
  };

  const initialFormState = {
    inputError:false,
    inputErrorMsg:"",
  }

  const [findLoading, setFindLoading] = useState(false);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [loadingButton, setLoadingButton] = useState(false);
  const [disable, setDisable] = useState(colors.primaryGreen);
  const [isFoundCM, setIsFoundCM] = useState(false);
  const [showCM, setShowCM] = useState(isFoundCM);
  const [formStates, setFormStates] = useState(initialFormState);
  const [isError, setIsError] = useState(false);

  const { loanBeneficiaryCreated } = useSelector(getLoanState);
  const { corpsmemberDetails, isLoading } = useSelector(getCMState);

  const CM = corpsmemberDetails?.data || {};

  const addCMsToLoan = () => {
    if (
      formValues.addCMtoLoanFormValues.cmName !== "" &&
      formValues.addCMtoLoanFormValues.cmStateCode !== "" &&
      formValues.addCMtoLoanFormValues.loanId !== ""
    ) {
      dispatch(addCMToLoan(formValues.addCMtoLoanFormValues));
      setLoadingButton(true);
      setIsFoundCM(true);
      setDisable(colors.secondaryGreen);
    }
    // else {
    //   setError(true);
    //   setHelperText("Please input a loan to add")
    // }
    setTimeout(() => {
      if (dispatch) {
        setLoadingButton(false);
      }
    }, 2000);
  };

  // this effect checks if loan is created and then closes the dialog and resetForm
  useEffect(() => {
    if (loanBeneficiaryCreated === true) {
      handleClose();
      setLoadingButton(false);
      dispatch(fetchLoans());
      dispatch(fetchLBToLoan(loanData?.id));
    }
    return () => {
      //   dispatch(emptyLoan())
      dispatch(restoreLBToLoanInitial());
    };
  }, [loanBeneficiaryCreated, dispatch]);

//   const LoanId = (e) => {
//     if (e) {
//       let loanNameValue = e.target.value;
//       setFormValues({
//         ...formValues,
//         name: loanNameValue,
//       });
//     }
//   };
// const handleIsFoundCM = () => {
//     setIsFoundCM(true);
//   };
  const handleResetFoundCM = () => {
    setIsFoundCM(false);
    dispatch(emptyCorpsMember());
  };

  const handleClose = () => {
    handleCloseAddCMToLoanDialog();
    setLoadingButton(false);
    handleResetFoundCM();
    setIsError(true)
  };

//   useEffect(() => {
//     if (Object.keys(CM).length === 0) {
//       setIsFoundCM(false);
//     }
//   }, [CM]);

const SetIsRequiredError = (
  value,
  stateError,
  stateErrorMsg,
  len = 1,
  errorMsg = "Field is required",
  max = 0,
  select = false
) => {
  if (!validators.isRequired(value, len, max, select)) {
    setFormStates((prevState) => [
      {
        ...prevState,
        [stateError]: true,
        [stateErrorMsg]: errorMsg,
      },
    ]);
    return false;
  }

  setFormStates({ ...formStates, [stateError]: false, [stateErrorMsg]: "" });
  return true;
};

  const StateCodeHandler = (e) => {
    let value = e.target.value;
    setFormValues((prevValues) => ({
      ...prevValues,
      stateCode: value,
      addCMtoLoanFormValues: {
        ...prevValues.addCMtoLoanFormValues,
        cmStateCode: value,
      },
    }));
    setFormStates({
      ...formStates,
      inputError: false,
      inputErrorMsg:  "",
    });
  };

//   const LoanIdHandler = () => {
//     
//     setFormValues((prevValues) => ({
//       ...prevValues,
//       addCMtoLoanFormValues: {
//         ...prevValues.addCMtoLoanFormValues,
//         loanId: loanData?.id,
//       },
//     }));
//   };

useEffect(() => {
    if (!isLoading && corpsmemberDetails) {
      setLoadingButton(false);
    }
  }, [isLoading, corpsmemberDetails]);

  useEffect(() => {
    if (showCM && !isLoading) {
      setShowCM(false);
    }
  }, [showCM, isLoading]);

  const findCMHandler = () => {
    const { addCMtoLoanFormValues, ...CMDetails } = formValues;
    if(formValues.stateCode === ""){
      debugger
      const isValid = SetIsRequiredError(
        formValues.stateCode,
        "inputError",
        "inputErrorMsg",
        11, // Minimum required length of input value
        "Please enter a valid input",
        12 // Maximum allowed length of input value
      );
      setFormStates({
        ...formStates,
        inputError: !isValid,
        inputErrorMsg: isValid ? "" : "*State code is required",
      });
      setIsError(true);
      setShowCM(false)
    }else{
    dispatch(fetchCorpsMember(CMDetails));
    setShowCM(true);
    setFindLoading(true);
    }
  };

  useEffect(()=>{
    if (Object.keys(corpsmemberDetails).length > 0){
        setFindLoading(false);
    }
  },[corpsmemberDetails])

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoadingButton(true);
//     dispatch(addCMToLoan(formValues.addCMtoLoanFormValues));
//   };

  useEffect(() => {
    if (Object.keys(corpsmemberDetails).length > 0) {
      setFormValues({
        ...formValues,
        addCMtoLoanFormValues: {
          cmName: corpsmemberDetails?.data?.cmName,
          cmStateCode: corpsmemberDetails?.data?.stateCode,
          loanId: loanData?.id,
        },
      });
    }
  }, [corpsmemberDetails]);
  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
        maxWidth={"sm"}
        open={addCMToLoanDialogIsOpen}
        PaperProps={{
          style: { borderRadius: "1rem" },
        }}
      >
        <DialogTitle
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          Add Corps Member to Loan
          <IconButton aria-label="Close" onClick={handleClose}>
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>

        <Box
        style={{
          padding: "0px 10px 0px 10px",
          display: "flex",
          alignItems: "center",
        }}
      > 

         <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{
                fontStyle: "italic",
                color: "#1d1d1d",
                margin: "15px 0px 5px 0px ",
              }}
            >
              Please enter the state code of the corps member
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                size="small"
                variant="outlined"
                value={formValues.cmStateCode}
                onChange={(e) => StateCodeHandler(e)}
                inputProps={{
                  spellCheck: true,
                  lang: "English",
                }}
                error={formStates.inputError}
                helperText={formStates.inputErrorMsg}
              />
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth>
              <LighterGreenButton
                loading={findLoading}
                fullWidth
                sx={{ padding: "8px", background: "#62AC87" }}
                onClick={findCMHandler}
              >
                <span style={{ marginRight: "10px" }}>Find</span>{" "}
                <Iconify icon="ic:twotone-search" width={20} height={20} />
              </LighterGreenButton>
            </FormControl>
          </Grid> 
           {!showCM &&
          !isLoading &&
          CM !== null &&
          Object.keys(CM).length > 0 ? (
            <Grid item xs={12}>
              <Box sx={{ mt: "20px" }}>
                <StyledDivider textAlign="left">
                  <Typography variant="subtitle2" sx={{ color: "#949494" }}>
                    Corps Member Details
                  </Typography>
                </StyledDivider>
                <FormControl fullWidth sx={{ margin: "20px 10px" }}>
                  <TextField
                    id="standard-read-only-input"
                    label="Full Name"
                    value={CM?.cmName}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </FormControl>
                <FormControl sx={{ margin: "20px 10px" }}>
                  <TextField
                    id="standard-read-only-input"
                    label="State Code"
                    value={CM?.stateCode}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </FormControl>
              </Box>
            </Grid>
          ) : showCM ? (
            <Skeleton
              animation="wave"
              variant="rounded"
              width={500}
              height={200}
              sx={{ margin: "30px 0px 3px 20px" }}
            />
          ) : !isLoading && Object.keys(CM).length === 0 ? (
            <Box
              mb={2}
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <div style={{textAlign:'center', textTransform:'initial'}}>
                <img
                  height={150}
                  width={150}
                  src={NotFoundImage}
                  alt="Corps Member not found."
                />
                <Typography variant="body2" >
                  Corps Member not found.  You may have searched for the wrong<br/> state code. Ensure the state code is correct.
                </Typography>
              </div>
            </Box> 
          ) : (
            <Box sx={{ height: "300px" }}></Box>
          )} 
         </Grid>
        </Box>
        
          {/* <Grid container spacing={2}>
            <Grid item xs={9}>
              <TextField
                size="small"
                fullWidth
                value={formValues.stateCode}
                onChange={(e) => StateCodeHandler(e)}
              />
            </Grid>
            <Grid item xs={3}>
              <Button variant="contained" onClick={findCMHandler}>
                Find
              </Button>
            </Grid>
          </Grid>

          
          <Grid container spacing={2} style={{marginTop: "20px"}}>
            <Grid
              item
              xs={6}
              style={{
                // marginBottom: "10px",
                // marginTop: "20px",
                fontSize: "14px",
              }}
            >
              <label
                style={{
                  marginBottom: "10px",
                  marginTop: "20px",
                  fontSize: "14px",
                  fontFamily: Typography.secondaryFont,
                }}
                for=""
              >
                Corps Member
              </label>
              <TextField
                value={corpsmemberDetails?.data?.cmName}
                size="small"
              />
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                // marginBottom: "10px",
                // marginTop: "20px",
                fontSize: "14px",
              }}
            >
              <label
                style={{
                  marginBottom: "10px",
                  marginTop: "20px",
                  fontSize: "14px",
                  fontFamily: Typography.secondaryFont,
                }}
                for=""
              >
                State Code
              </label>
              <TextField
                size="small"
                value={corpsmemberDetails?.data?.stateCode}
              />
            </Grid>
           
          </Grid>  */}
          
        </DialogContent>
        <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>

          <GreyOutlinedButton
            sx={{ padding: "8px 20px" }}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </GreyOutlinedButton>
          <LoadingButton
          color="primary"
          disabled={Object.keys(corpsmemberDetails).length===0 || corpsmemberDetails.data === null? true:false}
            loading={loadingButton}
            onClick={addCMsToLoan}
            sx={{
              textTransform: "capitalize",
              color: "#fff",
              borderColor: colors.primaryGreen,
              padding: "8px 25px",
              "&:hover": { borderColor: colors.darkGreen },
            }}
            variant="contained"
          >
            Add CM
          </LoadingButton>
          
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
